import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Suspense as _Suspense, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/assets/image/vipImg/icon_close.png'


const _hoisted_1 = { class: "set-shop-content" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "set-shop-dialog-title" }
const _hoisted_4 = { class: "set-shop-tab-content" }
const _hoisted_5 = { class: "set-shop-tab-content-point" }
const _hoisted_6 = { class: "set-shop-tab-content-text" }
const _hoisted_7 = { class: "add-shop" }
const _hoisted_8 = { class: "choose-system" }
const _hoisted_9 = { class: "choose-system-title" }
const _hoisted_10 = { class: "choose-system-radio" }
const _hoisted_11 = { class: "add-shop" }
const _hoisted_12 = { class: "add-shop" }
const _hoisted_13 = { class: "add-shop" }
const _hoisted_14 = { class: "set-shop-btn" }

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { isD2C, useSite, isEN } from '@/store'
import CreateShopItem from '@/components/common/CreateShopItem.vue'
import ShopPurchase from '@/views/setup/components/ShopPurchase.vue'
import ShopExpress from './ShopExpress.vue'
import { useStore } from 'vuex'
import { ElMessage as message } from 'element-plus'
import { wordBreak } from 'html2canvas/dist/types/css/property-descriptors/word-break'
import { getAllCustomerShopApi } from '@/apis/setup'
import { request } from '@/config/request/interceptors'
import { changeB2C } from '@/apis/login'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  vipInfo: {
    type: Object,
    default: () => { return {} }
  }
},
  emits: ['update:visible', 'submit'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()
const shopInfo: any = ref({})
const nowShopInfo: any = computed(() => {
  let shop = ''
  if (store.getters.user?.customerShopList) {
    store.getters.user.customerShopList.forEach((item: any) => {
      if (item.customerShopId === store.state.route.curShop) {
        shop = {
          ...item,
          customerShopPlatform: parseInt(item.shopPlatform)
        }
      }
    })
  }
  return shop
})


const systemSource = isD2C() ? 1 : 2
// 业务模式1 d2c 2 b2b
const systemMode = ref(systemSource)
const activeStep = ref(0)
// if (shopInfo.value.customerShopId) {
//   activeStep.value = 2
// }
const isNewCustomer = !shopInfo.value.customerShopId

const close = () => {
  store.commit('status/editing', false)
  emit('update:visible', false)
  emit('submit')
}
const createShopItemRef = ref()
const shopPurchaseRef = ref()
const shopExpressRef = ref()
const prev = () => {
  activeStep.value--
}
const next = async () => {
  console.log(activeStep.value, 'activeStep')
  console.log('1')
  if (activeStep.value === 0) {
    // 业务模式选择
    console.log('2')
    // 选择店铺信息
    if (systemSource === systemMode.value) {
      shopInfo.value = nowShopInfo.value
    } else {
      //  查询另一个子店铺信息
      const shopInfoList = await getAllCustomerShopApi()
      const info = shopInfoList.data?.find(v => v.systemSource === systemMode.value)
      shopInfo.value = info ?? {
        systemSource: systemMode.value
      }
    }
    console.log('info', shopInfo.value)
    if (!shopInfo.value.customerShopId) {
      const { data: { limitShopNum = 0, currentShopNum = 0 } = {} } = await request.customer.customer.shopGetShopNumLimit()
      if (limitShopNum <= currentShopNum) {
        message.warning(`【${t('您的店铺数量已达上限')}】，${t('您的会员仓位可创建的店铺个数上限为{x}个', { x: limitShopNum })}`)
        return
      }
    }
    activeStep.value = 1
  } else if (activeStep.value === 1) {
    console.log('2')
    createShopItemRef.value.checkForm((model: any) => {
      console.log('model', model)
      shopInfo.value = {
        ...shopInfo.value,
        ...model
      }
      activeStep.value = 2
    }, () => {
      message.warning(t('请填写完成店铺信息'))
    })
  } else if (activeStep.value === 2 && systemMode.value === 1) {
    shopPurchaseRef.value.checkForm(() => {
      activeStep.value = 3
    }, () => {
      message.warning(t('请填写完成采购设置'))
    })
    console.log('3')
  } else if (activeStep.value === 3 || (activeStep.value === 2 && systemMode.value === 2)) {
    console.log('4')
    // 保存
    // 第一步校验店铺信息是否完整
    console.log('5')
    // 第二步校验采购设置
    shopPurchaseRef.value.checkForm(() => {
      console.log('6')
      if (systemMode.value === 2) {
        createShopItemRef.value.authorize()
        return
      }
      console.log('7')
      // 第三步校验国际配送设置
      shopExpressRef.value.checkForm(() => {
        console.log('8')
        createShopItemRef.value.authorize()
      }, () => {
        message.warning(t('请填写完成国际配送设置'))
      })
    }, () => {
      activeStep.value = 2
      message.warning(t('请填写完成采购设置'))
    })
  }
}

// 店铺保存后回调
const shopSubmit = (id: any) => {
  console.log('店铺保存后回调')
  shopInfo.value.customerShopId = id
  // if (!shopInfo.value.customerShopId) {
  //   // 没有店铺先切换店铺
  //   // store.commit('route/SET_SHOP_ID', id)
  //   shopPurchaseRef.value.firstupdate(id)
  // } else {
  // }
  shopPurchaseRef.value.update()
}

// 采购设置保存
const purchaseSubmit = async () => {
  console.log('采购设置保存')
  if (systemMode.value === 1) {
    shopExpressRef.value.updateLogistics(isNewCustomer)
  } else {
    if (systemSource !== systemMode.value) {
      await changeB2C().then((res) => {
        store.dispatch('route/setPlat', res.data.token)
      })
    }
    emit('submit')
  }
}
const expressSubmit = async () => {
  if (systemSource !== systemMode.value) {
    await changeB2C().then((res) => {
      store.dispatch('route/setPlat', res.data.token)
    })
  }
  emit('submit')
}

const changeTab = (num: number) => {
  console.log(createShopItemRef.value.model)
  store.commit('route/SET_SHOP_INFO', createShopItemRef.value.model)
  activeStep.value = num
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "custom-class": "set-shop-dialog",
      "model-value": __props.visible,
      onClose: close,
      "append-to-body": "",
      "show-close": false,
      "destroy-on-close": true
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: close,
              class: "close-icon"
            }),
            _createElementVNode("div", _hoisted_3, [
              (_unref(isEN)())
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["title", _unref(useSite)()])
                  }, [
                    _createTextVNode(_toDisplayString(_unref(t)('恭喜成功开通')), 1),
                    _createElementVNode("span", null, "【" + _toDisplayString(__props.vipInfo.priceName) + "】", 1),
                    _createTextVNode(_toDisplayString(_unref(t)('为了更好地帮您履行下单履约，您需要提前填写以下信息。')), 1)
                  ], 2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["title", _unref(useSite)()])
                  }, [
                    _createElementVNode("span", null, "【" + _toDisplayString(__props.vipInfo.priceName) + "】", 1),
                    _createTextVNode(_toDisplayString(_unref(t)('恭喜成功开通')) + _toDisplayString(_unref(t)('为了更好地帮您履行下单履约，您需要提前填写以下信息。')), 1)
                  ], 2))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["point", { active: activeStep.value >= 0 }])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["line", { active: activeStep.value >= 1 }])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["point", { active: activeStep.value >= 1 }])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["line", { active: activeStep.value >= 2 }])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["point", { active: activeStep.value >= 2 }])
                }, null, 2),
                (systemMode.value === 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["line", { active: activeStep.value >= 3 }])
                    }, null, 2))
                  : _createCommentVNode("", true),
                (systemMode.value === 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["point", { active: activeStep.value >= 3 }])
                    }, null, 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["set-shop-tab-text", { active: activeStep.value >= 0 }])
                }, _toDisplayString(_unref(t)('业务模式选择')), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["set-shop-tab-text", { active: activeStep.value >= 1 }])
                }, _toDisplayString(_unref(t)('店铺设置')), 3),
                _createElementVNode("div", {
                  class: _normalizeClass(["set-shop-tab-text", { active: activeStep.value >= 2 }])
                }, _toDisplayString(_unref(t)('采购设置')), 3),
                (systemMode.value === 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["set-shop-tab-text", { active: activeStep.value >= 3 }])
                    }, _toDisplayString(_unref(t)('国际配送设置')), 3))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('请选择您首先要尝试的业务模式，后续可切换')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_radio_group, {
                  modelValue: systemMode.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((systemMode).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('b2b 我们支持持有库存并将其运送到您的家庭、内部仓库或国内电子商务仓库的操作。')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('d2c 支持从一点到直接交付给最终用户的操作')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ], 512), [
            [_vShow, activeStep.value === 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            _createVNode(CreateShopItem, {
              vip: true,
              ref: (_value, _refs) => {
                _refs['createShopItemRef'] = _value
                createShopItemRef.value = _value
              },
              shopData: shopInfo.value,
              onOk: shopSubmit
            }, null, 8, ["shopData"])
          ], 512), [
            [_vShow, activeStep.value === 1]
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(ShopPurchase, {
                  vip: true,
                  ref: (_value, _refs) => {
                    _refs['shopPurchaseRef'] = _value
                    shopPurchaseRef.value = _value
                  },
                  onOk: purchaseSubmit,
                  shopData: shopInfo.value
                }, null, 8, ["shopData"]), [
                  [_vShow, activeStep.value === 2]
                ])
              ]),
              _: 1
            }))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_13, [
            (_openBlock(), _createBlock(_Suspense, null, {
              default: _withCtx(() => [
                _createVNode(ShopExpress, {
                  vip: true,
                  ref: (_value, _refs) => {
                    _refs['shopExpressRef'] = _value
                    shopExpressRef.value = _value
                  },
                  onOk: expressSubmit,
                  shopData: shopInfo.value
                }, null, 8, ["shopData"])
              ]),
              _: 1
            }))
          ], 512), [
            [_vShow, activeStep.value === 3]
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_button, {
              class: "btn",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('暂不设置')), 1)
              ]),
              _: 1
            }),
            (activeStep.value !== 0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "btn",
                  onClick: prev
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('上一步')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "primary",
              class: "btn",
              style: {"margin-left":"20px"},
              onClick: next
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString((systemMode.value === 1 &&
            activeStep.value
            == 3
            ||
            systemMode.value === 2 && activeStep.value === 2) ? _unref(t)('保存设置') :
            _unref(t)('下一步')), 1)
              ]),
              _: 1
            })
          ])
        ], 512), [
          [_directive_loading, _unref(store).state.status.loading]
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})